/* eslint-disable @typescript-eslint/no-explicit-any */
import { render } from "preact";
import { addUpdatedContentDelegate } from "./init-updated";

export function createIsland(
    appSelectorAttributeValue: string,
    Component: any,
    options?: EnrichmentIslandOptions,
) {
    if (options?.editing !== true && isEditing()) {
        return;
    }

    const selector = `[app="${appSelectorAttributeValue}"]`;

    executeIsland(document, selector, Component);

    if (options?.modals) {
        addUpdatedContentDelegate((e) => executeIsland(e, selector, Component));
    }
}

export type EnrichmentIslandOptions = {
    editing?: boolean;
    modals?: boolean;
};

export function createEnrichmentIsland(
    selector: string,
    initCallback: (e: Element) => void,
    options?: EnrichmentIslandOptions,
) {
    if (options?.editing !== true && isEditing()) {
        return;
    }

    executeEnrichmentIsland(document, selector, initCallback);

    if (options?.modals) {
        addUpdatedContentDelegate((e) =>
            executeEnrichmentIsland(e, selector, initCallback),
        );
    }
}

const executeIsland = (
    parentElement: HTMLElement | HTMLDocument,
    selector: string,
    Component: any,
) =>
    executeEnrichmentIsland(parentElement, selector, (e) =>
        renderWithClientSideProps(e, Component),
    );

function executeEnrichmentIsland(
    parentElement: HTMLElement | HTMLDocument,
    selector: string,
    initCallback: (e: Element) => void,
) {
    parentElement.querySelectorAll(selector).forEach((elm: Element) => {
        initCallback(elm);
    });
}

let isEditingState: boolean | null = null;

export function isEditing(): boolean {
    if (isEditingState === null) {
        const b = document.querySelector("body");
        isEditingState = b?.classList.contains("editing") == true;
    }

    return isEditingState;
}

export function renderWithClientSideProps(element: Element, Component: any) {
    const props = getRenderedClietSideProps(element);
    element.innerHTML = "";
    render(<Component {...props}></Component>, element);
}

export function getRenderedClietSideProps(e: Element) {
    const json = e.querySelector('script[type="text/props"]')?.innerHTML;
    const props = json ? JSON.parse(json) : {};
    return props;
}
